<template>
  <div class="line-item-v2">
    <div class="d-flex mb-3 align-items-center justify-space-between flex-wrap">
      <div class="d-flex align-items-center">
        <v-autocomplete
          hide-details
          v-model.trim="module_type_top"
          :items="modulesType"
          clearable
          v-on:click:clear="module_type_top = null"
          style="max-width: 220px !important"
          dense
          flat
          filled
          placeholder="Select item type"
          item-color="cyan"
          class="mr-2 custom-boder-color"
          color="cyan"
          solo
          :menu-props="{ offsetY: true }"
          v-on:change="open_dialog($event, 'top')"
          item-value="value"
          item-text="text"
        >
        </v-autocomplete>
        <v-btn-toggle color="cyan" group class="rounded-lg">
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="header"
            v-on:click="add_header()"
            style="height: 32px !important"
          >
            Header
          </v-btn>
          <v-btn
            v-if="false"
            color="cyan"
            class="custom-bold-button"
            value="other"
            v-on:click="add_other()"
            style="height: 32px !important"
          >
            <v-icon small class="mr-1">mdi-plus</v-icon>
            Other
          </v-btn>
        </v-btn-toggle>
      </div>
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center ml-2 pl-3 custom-border-left">
          <label
            for="discount-level"
            class="mb-0 font-weight-600 font-size-13 color-custom-blue mr-2 text-nowrap"
            >Discount Level</label
          >
          <v-autocomplete
            :menu-props="{ offsetY: true }"
            :readonly="relatedDetail && relatedDetail.id > 0"
            hide-details
            v-model.trim="discount_level"
            :items="transactions"
            style="max-width: 180px !important"
            dense
            flat
            filled
            placeholder="Discount Level"
            item-color="cyan"
            class="custom-boder-color"
            color="cyan"
            solo
            v-on:change="calculate_total()"
            item-value="value"
            item-text="text"
          >
          </v-autocomplete>
        </div>
      </div>
    </div>

    <v-card
      flat
      outlined
      class="rounded-lg border-slate bg-white overflow-hidden mb-4 shadow-0"
    >
      <div
        class="d-flex grey lighten-4 border-bottom align-items-center px-3 py-2"
      >
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase text-center d-flex align-items-center justify-center"
          style="width: 4%"
        >
          #
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase text-left px-2 d-flex align-items-center"
          :style="{
            width: isPurchaseOrder
              ? discount_level == 'line_item'
                ? '24%'
                : '32%'
              : discount_level == 'line_item'
              ? '43%'
              : '56%',
          }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-package-variant-closed</v-icon
          >
          <template>Product / Service</template>
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-1 d-flex align-items-center justify-center text-center"
          style="width: 8%"
        >
          Type
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-1 d-flex align-items-center justify-center text-center"
          style="width: 11%"
        >
          Linked Quotation
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-1 d-flex align-items-center justify-center text-center"
          style="width: 11%"
        >
          Allocation
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-1 d-flex align-items-center justify-center text-center"
          :style="{ width: '10%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-tag-outline</v-icon
          >
          Purchase Cost
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-2 d-flex align-items-center justify-center text-center"
          :style="{ width: '7%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-ruler-square</v-icon
          >
          UOM
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-2 d-flex align-items-center justify-center text-center"
          :style="{ width: '7%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1">mdi-numeric</v-icon>
          Quantity
        </div>
        <div
          v-if="discount_level == 'line_item'"
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-2 d-flex align-items-center justify-center text-center"
          :style="{ width: '10%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-percent-outline</v-icon
          >
          Discount
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase px-2 d-flex align-items-center justify-center text-center"
          :style="{ width: '6%' }"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-cash-multiple</v-icon
          >
          Total
        </div>
        <div
          class="color-custom-blue font-weight-600 font-size-12 text-uppercase text-center"
          style="width: 4%"
        ></div>
      </div>
      <Draggable
        tag="ul"
        v-model="selected_line_items"
        class="line-item-drag-group mb-0 pa-0"
        draggable=".line-item-drag"
        handle=".line-item-drag-icon"
        ghost-class="line-item-ghost"
        :key="`line-item-img-${dialog_key}`"
        animation="200"
        group="line-item-drag"
        v-on:start="drag = true"
        v-on:end="drag = false"
        v-on:change="emit_values()"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <li
            v-for="(row, index) in selected_line_items"
            class="line-item-drag border-bottom border-slate-100 hover:bg-slate-50 transition-fast pa-0"
            :class="{
              'alternate-line-item-row bg-slate-50':
                selected_line_items[index + 1]?.is_child,
            }"
            :key="`line-item-drag-${index}`"
          >
            <div
              :id="`line-item-drag-${index}`"
              class="d-flex align-items-top py-2 px-3"
              :class="{ 'item-is-child pl-4': row.is_child }"
            >
              <div class="font-weight-600 text-center" style="width: 4%">
                <v-icon
                  v-if="!row.is_child"
                  class="line-item-drag-icon cursor-move text-slate-400 hover-cyan"
                  >mdi-drag</v-icon
                >
              </div>
              <div
                v-if="row.is_child"
                class="font-weight-600 text-center"
                style="width: 4%"
              >
                <v-icon
                  class="line-item-drag-icon cursor-move text-slate-400 hover-cyan"
                  >mdi-drag</v-icon
                >
              </div>
              <div
                v-if="row.type === 'header'"
                class="text-left px-2 d-flex align-items-center"
                style="width: 100%"
              >
                <v-text-field
                  v-model="row.product"
                  class="line-item-header-text px-0"
                  placeholder="Header Title"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  v-on:change="changeName(index, row.product)"
                  color="cyan"
                >
                  <template v-slot:append>
                    <v-chip
                      color="cyan white--text"
                      label
                      small
                      class="lip-type text-uppercase font-weight-600 header"
                    >
                      Header
                    </v-chip>
                  </template>
                </v-text-field>
              </div>
              <div
                v-else
                class="text-left px-2"
                :style="{
                  width: isPurchaseOrder
                    ? discount_level == 'line_item'
                      ? row.is_child
                        ? '19%'
                        : '24%'
                      : row.is_child
                      ? '27%'
                      : '32%'
                    : discount_level == 'line_item'
                    ? row.is_child
                      ? '38%'
                      : '43%'
                    : row.is_child
                    ? '51%'
                    : '56%',
                }"
              >
                <div class="d-flex align-items-top">
                  <v-avatar
                    size="32"
                    v-if="row.product_type != 'other'"
                    class="rounded-lg border"
                  >
                    <img
                      v-if="row?.image?.url"
                      :src="row?.image?.url"
                      :alt="row?.image?.name"
                    />
                    <img v-else :src="$defaultImage" />
                  </v-avatar>
                  <div style="width: 100%" class="ml-2">
                    <v-expansion-panels class="cepfli flat">
                      <v-expansion-panel class="bg-transparent">
                        <v-expansion-panel-header class="pa-0 min-height-unset">
                          <v-text-field
                            v-model="row.product"
                            class="line-item-header-text px-0"
                            placeholder="Product/Service"
                            dense
                            filled
                            solo
                            v-on:change="changeName(index, row.product)"
                            flat
                            hide-details
                            color="cyan"
                          >
                            <template v-slot:append>
                              <v-chip
                                color="cyan white--text"
                                label
                                small
                                class="lip-type text-uppercase font-weight-600"
                                :class="{
                                  product: row.product_type == 'goods',
                                  parts: row.product_type == 'parts',
                                  other: row.product_type == 'other',
                                }"
                              >
                                <template> {{ row.type }}</template>
                              </v-chip>
                            </template>
                          </v-text-field>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="px-0 pt-2">
                          <v-textarea
                            class="px-0 mb-0"
                            v-model="row.description"
                            placeholder="Description"
                            dense
                            filled
                            solo
                            flat
                            rows="2"
                            auto-grow
                            hide-details
                            color="cyan"
                            v-on:change="changeDes(index, row.description)"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <div class="d-flex align-items-center flex-wrap ml-0 mt-1">
                      <v-chip
                        v-if="row.barcode"
                        label
                        color="cyan darken-3"
                        outlined
                        x-small
                        class="font-weight-700 mr-2"
                        v-on:click="routeToDetail(row)"
                        >{{ row.barcode }}</v-chip
                      >
                      <template
                        v-if="
                          row.product_type == 'goods' ||
                          row.product_type == 'parts' ||
                          row.type == 'product' ||
                          row.type == 'parts'
                        "
                      >
                        <v-chip
                          :color="
                            row?.isSerialized
                              ? 'green darken-1'
                              : 'red lighten-1'
                          "
                          class="font-weight-600 mr-2"
                          x-small
                          label
                          text-color="white"
                        >
                          {{
                            row?.isSerialized ? "Serialized" : "Non-serialized"
                          }}
                        </v-chip>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="isPurchaseOrder && !(row.type == 'header')"
                class="text-center px-1"
                style="width: 8%"
              >
                <v-select
                  :menu-props="{ offsetY: true }"
                  v-model="row.po_type"
                  :items="['Quotation', 'Inventory']"
                  :readonly="
                    quotationRequired ||
                    row.type == 'other' ||
                    row.product_type == 'other'
                  "
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  color="cyan"
                  class="custom-po-type-select rounded-lg"
                  @change="onPoTypeChange(row)"
                ></v-select>
              </div>
              <div
                v-if="isPurchaseOrder && !(row.type == 'header')"
                class="text-center px-1"
                style="width: 11%"
              >
                <v-text-field
                  class="line-item-header-text px-0 cursor-pointer"
                  placeholder="Select quotation"
                  dense
                  filled
                  solo
                  flat
                  :value="
                    String(row.po_type).toLowerCase() === 'quotation'
                      ? row.linked_quotation || null
                      : '-'
                  "
                  :rules="
                    quotationRequired &&
                    String(row.po_type).toLowerCase() === 'quotation'
                      ? [
                          () =>
                            Number(row.quotation_id) > 0 ||
                            'Quotation is required',
                        ]
                      : []
                  "
                  :error="
                    quotationRequired &&
                    String(row.po_type).toLowerCase() === 'quotation' &&
                    !(Number(row.quotation_id) > 0)
                  "
                  readonly
                  color="cyan"
                  @click="openQuotationModal(row, index)"
                >
                  <template v-slot:append>
                    <v-icon
                      small
                      color="cyan darken-2"
                      @click.stop="openQuotationModal(row, index)"
                    >
                      mdi-format-quote-close
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
              <div
                v-if="isPurchaseOrder && !(row.type == 'header')"
                class="text-center px-1"
                style="width: 11%"
              >
                <v-text-field
                  class="line-item-header-text px-0 cursor-pointer"
                  placeholder="Allocation"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  readonly
                  :value="
                    String(row.po_type).toLowerCase() === 'quotation'
                      ? row.allocation_summary || ''
                      : '-'
                  "
                  color="cyan"
                  @click="
                    String(row.po_type).toLowerCase() === 'quotation' &&
                      openAllocationModal(row, index)
                  "
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="String(row.po_type).toLowerCase() === 'quotation'"
                      small
                      color="cyan darken-2"
                      @click.stop="openAllocationModal(row, index)"
                    >
                      mdi-call-split
                    </v-icon>
                  </template>
                </v-text-field>
                <div
                  v-if="hasInvalidAllocation(row)"
                  class="red--text text--darken-2 font-size-11 font-weight-600 mt-1"
                >
                  Allocation exceeds PO quantity.
                </div>
              </div>
              <div v-if="!(row.type == 'header')" class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '10%' : '12%' }">
                <PriceField class="line-item-header-text px-0" placeholder="Selling/Unit Cost" dense filled solo flat
                  hide-details type="text" inputmode="decimal" v-model="row.rate"
                  v-on:keyup="calculate_total()" color="cyan" />
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '7%' : '8%' }"
              >
                <v-autocomplete
                  :menu-props="{ offsetY: true }"
                  dense
                  filled
                  color="cyan"
                  item-color="cyan"
                  :items="unitList"
                  placeholder="UOM"
                  solo
                  flat
                  hide-details
                  item-text="text"
                  item-value="value"
                  class="pr-0 width-100"
                  v-model.trim="row.uom"
                  v-on:change="emit_values()"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No UOM Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '7%' : '8%' }"
              >
                <v-text-field
                  class="line-item-header-text px-0"
                  placeholder="Quantity"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  max="5000"
                  v-model="row.quantity"
                  :prepend="row.uom"
                  v-on:keyup="checkMaxQuantity(row), calculate_total()"
                  v-on:keypress="
                    isNumber($event);
                    row.product_type == 'service' &&
                      limitMaxLength($event, row.quantity, 4);
                  "
                  color="cyan"
                />
              </div>
              <div
                v-if="discount_level == 'line_item' && !(row.type == 'header')"
                class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '10%' : '13%' }"
              >
                <div class="d-flex">
                  <v-text-field
                    hide-details
                    class="line-item-header-text px-0"
                    placeholder="Discount"
                    dense
                    filled
                    solo
                    flat
                    type="number"
                    v-model="row.discount_value"
                    v-on:keyup="calculate_total()"
                    v-on:keypress="
                      limitDecimal($event, row.discount_value),
                        validateDiscountKeypress($event, row)
                    "
                    color="cyan"
                    style="width: 60%"
                    :readonly="row.quantity == 0"
                  />
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="discount_type_list"
                    v-model="row.discount_type"
                    hide-details
                    item-text="type"
                    item-value="value"
                    item-color="cyan"
                    class="line-item-header-text discount-type px-0 ml-1"
                    placeholder="Type"
                    dense
                    filled
                    solo
                    flat
                    v-on:change="calculate_total(), changeDiscountType2(row)"
                    color="cyan"
                    style="width: 40%"
                  />
                </div>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-1"
                :style="{ width: isPurchaseOrder ? '6%' : '8%' }"
              >
                <v-text-field
                  class="line-item-header-text px-0 font-weight-600"
                  placeholder="Total"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  v-model="row.total"
                  v-on:keyup="calculate_total()"
                  v-on:keypress="limitDecimal($event, row.total)"
                  color="cyan"
                />
              </div>
              <div
                class="font-weight-600 d-flex align-items-top justify-center"
                style="width: 4%"
              >
                <!-- <template v-if="!row.is_child">
                  <v-menu v-if="row.has_child" bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon small color="cyan darken-2">
                        <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="py-0 rounded-lg" min-width="160px">
                      <v-list-item v-if="!row.is_child" link class="border-bottom"
                        v-on:click="add_child(index, 'product')">
                        <v-list-item-title class="font-weight-600 font-size-13">
                          Add Product</v-list-item-title>
                      </v-list-item>

                      <v-list-item v-if="
                        !row.is_child && isPurchaseOrder
                      " link class="border-bottom" v-on:click="add_child(index, 'parts')">
                        <v-list-item-title class="font-weight-600 font-size-13">
                          Add Part</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template> -->
                <v-btn
                  v-on:click="remove_row(index, row)"
                  icon
                  small
                  color="red lighten-1"
                >
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </li>
        </transition-group>
      </Draggable>
      <template v-if="!selected_line_items.length">
        <div class="p-4 text-center">
          <p
            class="m-0 p-3 font-size-14 font-weight-500 text-slate-600 bg-slate-50 border-slate rounded-lg d-inline-flex align-items-center justify-center"
          >
            <v-icon color="cyan darken-2" small class="mr-2"
              >mdi-alert-circle-outline</v-icon
            >
            No line items added yet. Use the action bar above to add items.
          </p>
        </div>
      </template>
    </v-card>
    <div v-if="false" class="d-flex align-items-center">
      <v-autocomplete
        hide-details
        v-model.trim="module_type_bottom"
        :items="modulesType"
        clearable
        v-on:click:clear="module_type_bottom = null"
        style="max-width: 220px !important"
        dense
        flat
        filled
        placeholder="Select item type"
        item-color="cyan"
        class="mr-2 custom-boder-color"
        color="cyan"
        solo
        :menu-props="{ offsetY: true }"
        v-on:change="open_dialog($event, 'bottom')"
        item-value="value"
        item-text="text"
      >
      </v-autocomplete>
      <v-btn-toggle color="cyan" group class="rounded-lg">
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="header"
          v-on:click="add_header()"
          style="height: 32px !important"
        >
          Header
        </v-btn>
        <v-btn
          v-if="false"
          color="cyan"
          class="custom-bold-button"
          value="other"
          v-on:click="add_other()"
          style="height: 32px !important"
        >
          <v-icon small class="mr-1">mdi-plus</v-icon>
          Other
        </v-btn>
      </v-btn-toggle>
    </div>

    <!-- Summary & Totals Box -->
    <div class="d-flex justify-end mb-4">
      <v-card
        flat
        outlined
        class="rounded-lg bg-slate-50 pa-4 border-slate w-100 shadow-0"
        style="max-width: 550px"
      >
        <div
          class="d-flex align-items-center justify-space-between pb-2 mb-3 border-bottom"
        >
          <div class="d-flex align-items-center">
            <v-icon small color="cyan darken-2" class="mr-2"
              >mdi-calculator-variant-outline</v-icon
            >
            <span class="font-size-15 font-weight-700 color-custom-blue"
              >Summary & Totals</span
            >
          </div>
        </div>

        <table width="100%" style="table-layout: fixed">
          <tbody>
            <tr>
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Sub Total
              </td>
              <td width="30%" valign="middle" align="center" class="py-1"></td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(subtotal) }}
              </td>
            </tr>
            <tr v-if="discount_level == 'transaction'">
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Discount
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <div class="d-flex">
                  <v-text-field
                    hide-details
                    class="line-item-header-text px-0"
                    placeholder="Discount"
                    dense
                    filled
                    solo
                    flat
                    v-model="discount_value"
                    v-on:keyup="calculate_total(), checkData()"
                    v-on:keypress="
                      limitDecimal($event, discount_value),
                        checkData(),
                        manageDiscount($event)
                    "
                    v-on:paste="validateTransactionDiscountPaste($event)"
                    v-on:change="checkData()"
                    color="cyan"
                  />

                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="discount_type_list"
                    v-model="discount_type"
                    hide-details
                    item-text="type"
                    item-value="value"
                    item-color="cyan"
                    class="line-item-header-text discount-type px-0 ml-1"
                    placeholder="Type"
                    dense
                    filled
                    solo
                    flat
                    v-on:change="calculate_total(), changeDiscountType()"
                    color="cyan"
                  />
                </div>
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(discount) }}
              </td>
            </tr>
            <tr>
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Tax [GST {{ gst_value }}%]
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <v-checkbox
                  v-on:change="calculate_total()"
                  v-model="tax_active"
                  class="my-0 py-0 px-0 mx-0"
                  color="cyan"
                  hide-details
                  :label="`Apply Tax`"
                />
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(gst) }}
              </td>
            </tr>
            <tr>
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Adjustment
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <v-text-field
                  hide-details
                  class="line-item-header-text px-0 line-item-adjustment"
                  placeholder="Adjustment"
                  dense
                  filled
                  solo
                  flat
                  v-model="adjustment"
                  v-on:keyup="calculate_total(), checkData()"
                  v-on:keypress="
                    limitDecimal($event, adjustment),
                      checkData(),
                      limitMaxLength($event, adjustment, 10)
                  "
                  :maxlength="10"
                  color="cyan"
                >
                  <template v-slot:append>
                    <v-btn
                      x-small
                      depressed
                      color="cyan darken-2 white--text"
                      class="px-2 rounded-sm"
                      v-on:click="auto_adjust()"
                      >Auto</v-btn
                    >
                  </template>
                </v-text-field>
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(adjustment) }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="d-flex align-items-center justify-space-between pa-3 rounded-lg bg-cyan-50 border-top mt-3"
        >
          <span class="font-size-15 font-weight-700 text-slate-900"
            >Grand Total</span
          >
          <span class="font-size-20 font-weight-800 color-custom-blue">{{
            formatMoney(total)
          }}</span>
        </div>
      </v-card>
    </div>
    <LineItemDialog
      :key="`line-item-dialog-${dialog_key}`"
      :product-type="product_type"
      :isType="relatedType"
      :product-dialog="product_dialog"
      :module-type="relatedType"
      :supplier="supplier"
      v-on:update-values="update_line_item($event)"
      v-on:close="closeProductDialog"
    />
    <div class="d-none">
      <v-file-input
        :ref="`line-item-image`"
        v-on:change="updateProfileImage"
        multiple
        accept="image/png, image/jpeg, image/jpg"
      ></v-file-input>
    </div>

    <ManageUnit
      :u-dialog="manageUnitDialog"
      :unit="unitList"
      v-on:close-dialog="manageUnitDialog = false"
      v-on:get-product-unit="getOptions"
    ></ManageUnit>

    <SelectAcceptedQuotationModal
      v-model="quotationDialog"
      :quotation-list="quotationList"
      :loading="quotationListLoading"
      :loading-more="quotationListLoadingMore"
      :has-more="quotationListHasMore"
      @select="onSelectQuotation"
      @search="searchQuotations"
      @load-more="loadMoreQuotations"
    ></SelectAcceptedQuotationModal>

    <AllocateQuantityModal
      v-model="allocationDialog"
      :item-data="selectedRowForAllocation || {}"
      @save="onSaveAllocation"
    >
    </AllocateQuantityModal>
  </div>
</template>

<script>
import { QUERY, GET } from "@/core/services/store/request.module";
import { mapGetters } from "vuex";
import Draggable from "vuedraggable";
import LineItemDialog from "@/view/components/LineItemDialog.vue";
import AppConfiguration from "@/core/config/app.config.js";
import {
  SET_VISIT_LINE_ITEM,
  SET_VISIT_CALCULATION,
} from "@/core/services/store/visit.module";
import { UPDATE_SCHEDULE_STATE } from "@/core/services/store/invoice.module";
import { toBtxNumber, toBtxFixed } from "@/core/services/common.service";
import CommonMixin from "@/core/plugins/common-mixin.js";
import { find } from "lodash";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { v4 as uuidv4 } from "uuid";
import ManageUnit from "@/view/pages/partials/Manage-Part-Unit.vue";
import SelectAcceptedQuotationModal from "@/view/pages/partials/SelectAcceptedQuotationModal.vue";
import AllocateQuantityModal from "@/view/pages/partials/AllocateQuantityModal.vue";

export default {
  name: "line-item-v1",
  model: {
    prop: "value",
    event: "input",
  },
  mixins: [CommonMixin],
  data() {
    return {
      drag: false,
      unitList: [],
      manageUnitDialog: false,
      module_type_top: null,
      module_type_bottom: null,
      modulesType: [
        {
          value: "goods",
          text: "Product",
          show: true,
        },
        {
          value: "parts",
          text: "Part",
          show: true,
        },
      ],
      dialog_key: Number(new Date()),
      product_type: null,
      product_dialog: false,
      dialog_position: false,
      child_index: null,
      append_child: false,
      tax_active: false,
      pageLoading: false,
      show_price: false,
      transactions: [
        {
          text: "Transaction",
          value: "transaction",
        },
        {
          text: "Line Item",
          value: "line_item",
        },
      ],
      discount_level: "transaction",
      imageSrc: [],
      selected_line_items: [],
      currentEntityDb: {},
      subtotal: 0,
      discount: 0,
      gst: 0,
      gst_amount: 0,
      gst_value: 9,
      adjustment: 0,
      total_non_text_amount: 0,
      total: 0,
      customIndex: 0,
      discount_value: null,
      discount_type: 1,
      /*   localEntity: [], */
      discount_type_list: [
        { type: "%", value: 2 },
        { type: "$", value: 1 },
      ],
      duplicate_line_item_found: false,
      quotationDialog: false,
      quotationList: [],
      quotationListLoaded: false,
      quotationListLoading: false,
      quotationListLoadingMore: false,
      quotationListPage: 1,
      quotationListHasMore: false,
      allocationDialog: false,
      selectedRowForAllocation: null,
    };
  },
  props: {
    isPurchaseOrder: {
      type: Boolean,
      default: false,
    },
    quotationRequired: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    relatedDetail: {
      type: Object,
      default: null,
    },
    entityId: {
      type: Number,
      default: 0,
    },
    relatedType: {
      type: Number,
      default: 3,
    },
    isCustomerRequired: {
      type: Boolean,
      default: false,
    },
    itemSet: {
      type: Boolean,
      default: false,
    },
    itemSource: {
      type: String,
      default: null,
    },
    supplier: {
      type: [Number, String],
      default: 0,
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(items) {
        if (items !== this.selected_line_items) {
          this.selected_line_items = Array.isArray(items) ? items : [];
        }
      },
    },
    selected_line_items: {
      deep: true,
      handler(items) {
        clearTimeout(this.qtyWatcherTimer);

        this.qtyWatcherTimer = setTimeout(() => {
          items.forEach((row) => {
            const qty = toBtxNumber(row.quantity);
            const rate = toBtxNumber(row.rate);
            const lineTotal = qty * rate;

            if (qty === 0) {
              row.discount_value = null;
              row.total = 0;
              return;
            }

            if (row.discount_type == 1 && row.discount_value > lineTotal) {
              row.discount_value = 0;
            }

            if (row.discount_type == 2 && row.discount_value > 100) {
              row.discount_value = 100;
            }
          });

          this.calculate_total();
        }, 300);
      },
    },
    relatedDetail: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param && param.line_item) {
          this.selected_line_items = param.line_item;
          this.selected_line_items.forEach((item) => {
            if (
              item.isSerialized == 1 ||
              item.serial_number == 1 ||
              (item.main_product && item.main_product.serial_number == 1) ||
              (item.serialize_number && item.serialize_number.length > 0)
            ) {
              item.isSerialized = 1;
            }
            if (
              item.serialize_number &&
              item.serialize_number.length &&
              (!item.serialNumber || !item.serialNumber.length)
            ) {
              const mappedSerials = item.serialize_number.map((x) =>
                typeof x === "object" ? x.serial_number_id || x.id : Number(x)
              );
              item.serialNumber = mappedSerials;
              item.adjust_serial_array = mappedSerials;
            }
          });
        }
      },
    },
    itemSet: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.selected_line_items = this.vSelectedLineItem;
          this.selected_line_items.map((row, index) => {
            this.selected_line_items[index].discount_type =
              this.lodash.toSafeInteger(row.discount_type);
            this.selected_line_items[index].cimages = row.item_images;
          });
          (this.show_price = param.show_price == 1 ? true : false),
            (this.adjustment = param.adjustment);
          this.gst_value =
            param.tax_value > 0
              ? param.tax_value
              : this.currentEntityDb.gstvalue;
          this.tax_active = param.tax_applied == 1 ? true : false;
          this.discount_level =
            param.discount_type == 1 ? "transaction" : "line_item";
          this.uom = param.uom ?? null;
          if (param && param.discount_value_type) {
            this.discount_value = param.discount_value;
            this.discount_type = this.lodash.toSafeInteger(
              param.discount_value_type
            );
          }
          this.calculate_total();
        }
      },
    },
    quotationRequired: {
      immediate: true,
      handler(required) {
        if (!required || !Array.isArray(this.selected_line_items)) {
          return;
        }

        this.selected_line_items.forEach((row) => {
          const isHeader =
            row.type === "header" || row.product_type === "header";

          const isOther = row.type === "other" || row.product_type === "other";

          if (!isHeader && !isOther) {
            this.$set(row, "po_type", "Quotation");
          }
        });

        this.emit_values();
      },
    },
  },
  methods: {
    validateSellingCostInput(event) {
      if (
        event.ctrlKey ||
        event.metaKey ||
        [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "Home",
          "End",
          "Tab",
          "Enter",
          "Escape",
          "Shift",
        ].includes(event.key)
      ) {
        return;
      }

      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const nextValue = value.slice(0, start) + event.key + value.slice(end);

      if (
        event.key.length !== 1 ||
        !/^\d{0,6}(?:\.\d{0,2})?$/.test(nextValue)
      ) {
        event.preventDefault();
      }
    },
    validateSellingCostPaste(event) {
      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const pastedValue = event.clipboardData.getData("text");
      const nextValue = value.slice(0, start) + pastedValue + value.slice(end);

      if (!/^\d{0,6}(?:\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
      }
    },
    validateTransactionDiscountPaste(event) {
      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const pastedValue = event.clipboardData.getData("text");
      const nextValue =
        value.substring(0, start) + pastedValue + value.substring(end);

      if (!/^\d*(?:\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
        return;
      }

      const discountValue = Number(nextValue);
      const exceedsLimit =
        (this.discount_type == 1 && discountValue > Number(this.subtotal)) ||
        (this.discount_type == 2 && discountValue > 100);

      if (exceedsLimit) {
        event.preventDefault();
      }
    },
    validateDiscountKeypress(event, row) {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ];
      if (allowedKeys.includes(event.key)) return;

      const currentValue = event.target.value || "";
      const nextValue = Number(currentValue + event.key);

      // % discount → max 100 ONLY
      if (row.discount_type == 2) {
        if (nextValue > 100) {
          event.preventDefault();
        }
        return;
      }

      // flat discount → max rate
      const rate = Number(row.rate || 0);
      if (nextValue > rate) {
        event.preventDefault();
      }
    },
    checkMaxQuantity(row) {
      if (Number(row.quantity) > 5000) {
        ErrorEventBus.$emit(
          "update:error",
          "Purchase order quantity cannot exceed 5000"
        );
        row.quantity = 5000;
      }
    },
    changeDiscountType2(row) {
      if (row.discount_type == 2) {
        if (Number(row.discount_value) > 100) {
          row.discount_value = 100;
        }
      }

      // Flat discount
      if (row.discount_type == 1) {
        row.discount_value = 0;
      }

      this.calculate_total();
    },

    changeDiscountType() {
      if (this.discount_type == 2 && this.discount_value > 100) {
        this.discount_value = 100;
      }
      this.calculate_total();
    },
    manageDiscount($event) {
      const e = $event;
      const input = e.target;
      const key = e.key || String.fromCharCode(e.which || e.keyCode);
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
          event.key
        )
      ) {
        return;
      }
      const newValue =
        input.value.substring(0, input.selectionStart) +
        key +
        input.value.substring(input.selectionEnd);
      if (isNaN(newValue)) {
        e.preventDefault();
        return;
      }
      if (
        (Number(newValue) > Number(this.subtotal) && this.discount_type == 1) ||
        (Number(newValue) > 100 && this.discount_type == 2)
      ) {
        e.preventDefault();
        return;
      }
    },
    getOptions() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "setting/get-all-unit",
        })
        .then((response) => {
          _this.unitList = response.data;
          _this.$emit("close-dialog", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    async updateProfileImage(param) {
      if (param && param.length) {
        const promises = [];
        for (let i = 0; i < param.length; i++) {
          const image = await this.convertImageToBase64(param[i]);
          promises.push(image);
        }
        const lineItems = this.lodash.cloneDeep(this.selected_line_items);
        const _cimage = lineItems[this.customIndex].cimages
          ? lineItems[this.customIndex].cimages
          : [];
        lineItems[this.customIndex].cimages = [..._cimage, ...promises];
        this.selected_line_items = lineItems;
        this.$nextTick(() => {
          this.emit_values();
        });
        this.$refs[`line-item-image`].$refs["input"].value = null;
        this.imageSrc = [];
      }
    },
    convertImageToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.imageSrc.push(reader.result);
          resolve(reader.result);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },
    auto_adjust() {
      let total = toBtxNumber(this.total);
      if (total > 0) {
        let adjustment = toBtxFixed(total / 10) * 10 - total;
        this.adjustment = toBtxFixed(adjustment);
        this.$nextTick(() => {
          this.calculate_total();
        });
      }
    },
    routeToDetail(data) {
      let routeName = null;
      if (data.product_type == "goods") {
        routeName = "product.detail";
      } else if (data.product_type == "parts") {
        routeName = "part.detail";
      }
      if (data && data.product_id && data.product_id > 0) {
        this.$router.replace(
          this.getDefaultRoute(routeName, {
            params: { id: data.product_id },
          })
        );
      }
    },
    calculate_total() {
      let d_type = this.discount_level;

      this.subtotal = 0;
      this.discount = 0;
      this.gst = 0;
      this.gst_amount = 0;
      this.total_non_text_amount = 0;

      for (let i = 0; i < this.selected_line_items.length; i++) {
        let total = this.accountingToFixed(
          toBtxNumber(this.selected_line_items[i].quantity) *
            toBtxNumber(this.selected_line_items[i].rate)
        );
        let discount = 0;

        if (d_type == "line_item") {
          if (
            this.lodash.toSafeInteger(
              this.selected_line_items[i].discount_type
            ) == 1
          ) {
            discount = toBtxNumber(this.selected_line_items[i].discount_value);
          }
          if (
            this.lodash.toSafeInteger(
              this.selected_line_items[i].discount_type
            ) == 2
          ) {
            discount = this.accountingToFixed(
              (toBtxNumber(total) *
                toBtxNumber(this.selected_line_items[i].discount_value)) /
                100
            );
          }
        }
        this.selected_line_items[i].total =
          isNaN(total) || !total
            ? 0
            : toBtxNumber(total) - toBtxNumber(discount);
        this.subtotal = this.accountingToFixed(
          toBtxNumber(this.subtotal) +
            toBtxNumber(this.selected_line_items[i].total)
        );
      }

      let subtotal = this.subtotal;

      if (d_type == "transaction") {
        this.discount = 0;
        if (this.discount_type == 1) {
          this.discount = toBtxNumber(this.discount_value);
          if (this.discount > subtotal) {
            this.discount_value = 0;
            this.discount = 0;
          }
        }
        if (this.discount_type == 2) {
          this.discount = this.accountingToFixed(
            (toBtxNumber(subtotal) * toBtxNumber(this.discount_value)) / 100
          );
        }
      }

      subtotal = toBtxNumber(subtotal) - toBtxNumber(this.discount);

      this.total_non_text_amount = subtotal;
      if (this.tax_active) {
        this.gst_amount = subtotal;
        this.gst = this.accountingToFixed(
          (toBtxNumber(subtotal) * toBtxNumber(this.gst_value)) / 100
        );
      }

      subtotal = toBtxNumber(subtotal) + toBtxNumber(this.gst);

      this.total = this.accountingToFixed(
        toBtxNumber(subtotal) + toBtxNumber(this.adjustment)
      );
      this.emit_values();
    },
    getLineItemSelectionKey(item) {
      if (!item) {
        return null;
      }

      let productType = (item.product_type || item.type || "")
        .toString()
        .toLowerCase();

      const productTypeAliases = {
        product: "goods",
        part: "parts",
      };
      productType = productTypeAliases[productType] || productType;
      const productId =
        item.product_id ??
        item.main_product_id ??
        item.main_product?.id ??
        item.product?.id;
      if (productId !== null && productId !== undefined && productId !== "") {
        return `${productType}:product:${productId}`;
      }

      return null;
    },
    getUniqueLineItems(items) {
      const selectedKeys = new Set(
        this.selected_line_items
          .map((item) => this.getLineItemSelectionKey(item))
          .filter(Boolean)
      );
      const uniqueItems = [];
      let hasDuplicate = false;
      const duplicateMessages = [];

      items.forEach((item) => {
        const key = this.getLineItemSelectionKey(item);

        if (key && selectedKeys.has(key)) {
          hasDuplicate = true;
          const duplicateLabel = item?.barcode || item?.product || "Item";
          duplicateMessages.push(`${duplicateLabel} already used `);
          return;
        }

        uniqueItems.push(item);
        if (key) {
          selectedKeys.add(key);
        }
      });

      if (hasDuplicate) {
        this.duplicate_line_item_found = true;
        ErrorEventBus.$emit("update:error", duplicateMessages);
      }

      return uniqueItems;
    },
    update_line_item(param) {
      this.duplicate_line_item_found = false;
      param = this.getUniqueLineItems(Array.isArray(param) ? param : []);
      if (this.duplicate_line_item_found) {
        return;
      }
      if (!param.length) {
        return;
      }
      try {
        this.lastUpdateParam = this.lodash.cloneDeep(param);
      } catch (e) {
        this.lastUpdateParam = param;
      }
      for (let item of param) {
        if (item.serial_number == 1 || item.isSerialized == 1) {
          item.isSerialized = 1;
        }
      }
      if (this.quotationRequired) {
        for (let item of param) {
          const isHeader =
            item.type === "header" || item.product_type === "header";

          const isOther =
            item.type === "other" || item.product_type === "other";

          if (!isHeader && !isOther) {
            this.$set(item, "po_type", "Quotation");
          }
        }
      } else {
        for (let item of param) {
          if (!item.po_type) {
            this.$set(item, "po_type", "Inventory");
          }
        }
      }
      if (this.append_child) {
        let child_index = toBtxNumber(this.child_index);
        for (let item of param) {
          item.is_child = true;
          child_index = child_index + 1;
          this.selected_line_items = this.arrayInsert(
            this.selected_line_items,
            child_index,
            item
          );
        }
      } else if (this.dialog_position == "bottom") {
        {
          for (let item of param) {
            this.selected_line_items.push(item);
          }
        }
      } else if (this.dialog_position === "top") {
        for (let item of param) {
          this.selected_line_items.unshift(item);
        }
      } else {
        for (let item of param) {
          this.selected_line_items.push(item);
        }
      }

      this.calculate_total();

      this.$nextTick(() => {
        this.emit_values();
        if (!this.duplicate_line_item_found) {
          this.product_dialog = false;
          this.append_child = false;
          this.product_type = null;
          this.child_index = null;
        }
        this.duplicate_line_item_found = false;
      });
    },
    checkData() {
      if (this.discount_type == 2 && this.discount_value) {
        if (this.discount_value > 100) {
          this.discount_value = 100;
        }
      }
    },
    changeDes(index, row) {
      this.selected_line_items[index].description = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeName(index, row) {
      const trimmedValue = row.trim();
      this.selected_line_items[index].product = trimmedValue || "";
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    add_child(index, type) {
      this.append_child = true;
      this.dialog_key = Number(new Date());
      this.child_index = index;
      if (type == "product" || type == "parts") {
        this.product_type = type;
        this.product_dialog = true;
      }
    },
    emit_values() {
      this.$nextTick(() => {
        const payload = {
          discount_type: this.lodash.toSafeInteger(this.discount_type),
          discount_value: this.discount_value,
          tax_active: this.tax_active,
          adjustment: this.adjustment,
          uom: this.uom,
          visit_amount: this.total,
          show_price: this.show_price,
          discount_level: this.discount_level,
          calculate_total: this.calculate_total,
          tax_value: this.gst_value,
          total_non_text_amount: this.total_non_text_amount,
        };

        this.$store.dispatch(SET_VISIT_CALCULATION, payload);
        this.$store.dispatch(SET_VISIT_LINE_ITEM, this.selected_line_items);
        this.$emit("input", this.selected_line_items);
        this.$emit("update:total", {
          calculation: payload,
          "line-item": this.selected_line_items,
          allocationInvalid: this.hasInvalidAllocations(),
        });
      });
    },

    open_dialog(param, position) {
      if (!param) {
        return false;
      }
      if (!position) {
        this.position = null;
      }
      this.dialog_key = Number(new Date());
      this.product_type = param;
      this.product_dialog = true;
      this.dialog_position = position;
    },
    closeProductDialog() {
      const keepOpen = this.duplicate_line_item_found;
      this.duplicate_line_item_found = false;
      this.product_dialog = keepOpen;

      if (!keepOpen) {
        if (this.dialog_position === "top") {
          this.module_type_top = null;
        } else if (this.dialog_position === "bottom") {
          this.module_type_bottom = null;
        }
        this.product_type = null;
      }
    },
    add_header() {
      let len = this.selected_line_items.length + 1;
      this.selected_line_items.push({
        status: true,
        index: uuidv4(),
        uuid: uuidv4(),
        id: 0,
        order: len,
        type: "header",
        product_type: "header",
        is_child: false,
        has_child: false,
        has_property: false,
        product: null,
      });
      this.$nextTick(() => {
        this.product_type = null;
        this.emit_values();
      });
    },
    add_other() {
      let len = this.selected_line_items.length + 1;
      this.selected_line_items.push({
        status: true,
        index: uuidv4(),
        uuid: uuidv4(),
        id: null,
        image: {},
        order: len,
        serial_no: null,
        eq_model: null,
        location: null,
        group: null,
        discount: 0,
        type: "other",
        is_child: false,
        parent_uuid: null,
        has_child: true,
        has_property: true,
        property: {},
        group_primary: false,
        discount_value: 0,
        discount_type: 1,
        to_equipment: 0,
        product: null,
        project_price: 0,
        threshold_price: 0,
        product_id: 0,
        product_type: "other",
        description: null,
        has_warranty: false,
        rate: 0,
        selling_cost: 0,
        quantity: 1,
        uom: null,
        total: 0,
      });
      this.$nextTick(() => {
        this.product_type = null;
        this.emit_values();
      });
    },
    remove_row(index, row) {
      if (row.preventive_id > 0 && row.id > 0 && row?.is_consumed > 0) {
        this.$emit("remove:payload", row);
      }

      this.selected_line_items.splice(index, 1);
      this.calculate_total();
      this.emit_values();
    },
    isGSTAllowed() {
      const app_config = AppConfiguration.get();
      const { entity } = app_config;
      const currentEntity = find(entity, { id: this.entityId });
      this.currentEntityDb = currentEntity;
      this.gst_value = currentEntity.gstvalue > 0 ? currentEntity.gstvalue : 9;

      if (currentEntity) {
        if (currentEntity.gst) {
          this.tax_active = false;
        }
      }
      return true;
    },
    openQuotationModal(row, index) {
      if (String(row.po_type).toLowerCase() !== "quotation") {
        return;
      }

      this.selectedRowForQuotation = row;
      this.quotationRowIndex = index;
      this.quotationDialog = true;

      if (this.quotationListLoaded) {
        this.quotationListLoading = false;
        return;
      }

      this.quotationListLoading = true;

      this.$store
        .dispatch(QUERY, {
          url: "purchase-order/quotation-options",
          data: {
            current_page: 1,
            per_page: 5,
          },
        })
        .then(({ data }) => {
          this.quotationList = Array.isArray(data?.rows) ? data.rows : [];
          this.quotationListPage = Number(data?.current_page || 1);
          this.quotationListHasMore =
            this.quotationListPage < Number(data?.total_pages || 1);
          this.quotationListLoaded = true;
          this.quotationListLoading = false;
        })
        .catch(() => {
          this.quotationList = [];
          this.quotationListLoading = false;
        });
    },
    searchQuotations(search) {
      this.quotationListPage = 1;
      this.$store
        .dispatch(QUERY, {
          url: "purchase-order/quotation-options",
          data: { search: search || null, current_page: 1, per_page: 5 },
        })
        .then(({ data }) => {
          this.quotationList = Array.isArray(data?.rows) ? data.rows : [];
          this.quotationListPage = Number(data?.current_page || 1);
          this.quotationListHasMore =
            this.quotationListPage < Number(data?.total_pages || 1);
        })
        .catch(() => {
          this.quotationList = [];
        });
    },
    loadMoreQuotations(search) {
      if (this.quotationListLoadingMore || !this.quotationListHasMore) return;
      this.quotationListLoadingMore = true;
      this.$store
        .dispatch(QUERY, {
          url: "purchase-order/quotation-options",
          data: {
            search: search || null,
            current_page: this.quotationListPage + 1,
            per_page: 5,
          },
        })
        .then(({ data }) => {
          this.quotationList = this.quotationList.concat(data?.rows || []);
          this.quotationListPage = Number(
            data?.current_page || this.quotationListPage
          );
          this.quotationListHasMore =
            this.quotationListPage <
            Number(data?.total_pages || this.quotationListPage);
        })
        .finally(() => {
          this.quotationListLoadingMore = false;
        });
    },
    onPoTypeChange(row) {
      if (String(row.po_type).toLowerCase() !== "quotation") {
        this.$set(row, "linked_quotation", null);
        this.$set(row, "quotation_id", null);
        this.clearQuotationAllocations(row);
        this.emit_values();
      }
    },
    clearQuotationAllocations(row) {
      this.$set(row, "allocations", []);
      this.$set(row, "visit_allocations", []);
      this.$set(row, "allocation_summary", "");
    },
    onSelectQuotation(item) {
      if (
        this.quotationRowIndex !== null &&
        this.selected_line_items[this.quotationRowIndex]
      ) {
        const row = this.selected_line_items[this.quotationRowIndex];
        if (Number(row.quotation_id) !== Number(item.id)) {
          this.clearQuotationAllocations(row);
        }
        this.$set(row, "linked_quotation", item.barcode);
        this.$set(row, "quotation_id", item.id);
        this.emit_values();
      }
    },
    openAllocationModal(row, index) {
      const quotationId = Number(row.quotation_id || row.quotation) || null;
      if (quotationId && Number(row.quotation_id) !== quotationId) {
        this.$set(row, "quotation_id", quotationId);
      }
      this.selectedRowForAllocation = row;
      this.allocationRowIndex = index;
      this.allocationDialog = true;
    },
    onSaveAllocation(data) {
      if (
        this.allocationRowIndex !== null &&
        this.selected_line_items[this.allocationRowIndex]
      ) {
        this.$set(
          this.selected_line_items[this.allocationRowIndex],
          "allocation_summary",
          data.summary
        );
        this.$set(
          this.selected_line_items[this.allocationRowIndex],
          "allocations",
          data.allocations
        );
        this.emit_values();
      }
    },
    hasInvalidAllocation(row) {
      const allocations = Array.isArray(row.allocations)
        ? row.allocations
        : Array.isArray(row.visit_allocations)
        ? row.visit_allocations
        : [];
      const allocatedQuantity = allocations.reduce((total, allocation) => {
        if (allocation.isWarehouse) return total;
        return total + Number(allocation.allocated || allocation.quantity || 0);
      }, 0);

      return allocatedQuantity > Number(row.quantity || 0);
    },
    hasInvalidAllocations() {
      return this.selected_line_items.some((row) =>
        this.hasInvalidAllocation(row)
      );
    },
  },
  components: {
    ManageUnit,
    Draggable,
    LineItemDialog,
    SelectAcceptedQuotationModal,
    AllocateQuantityModal,
  },
  mounted() {
    this.getOptions();
    this.isGSTAllowed();
  },
  created() {
    const relatedId = Number(this.$route?.query?.edit ?? 0);
    if (relatedId > 0) {
      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "isEdit",
        value: true,
      });
    }
  },
  computed: {
    ...mapGetters(["vSelectedLineItem", "isEdit"]),
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
